import dayjs from 'dayjs';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase, onValue, ref, query, orderByValue, orderByKey, orderByPriority, orderByChild, limitToFirst, startAfter, startAt, limitToLast, endBefore } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import PropTypes from 'prop-types'
import React, { PureComponent, useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';

import { AuthContext } from '../../context/auth';
import { SelectContext } from '../../context/select';
import { TaskContext } from '../../context/task';
import { TotalViewContext } from '../../context/totalview';
import { firebaseConfig } from '../../firebaseConfig';
import logo from '../../img/kOnzy.gif';
import SearchBar from '../forms/searchBar';
import Timer from '../hooks/Timer';
import useSearch from '../hooks/useSearch';
import UpdateTask from './UpdateTask';



dayjs.extend(require("dayjs/plugin/relativeTime"))

export default function ListTask() {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Cloud Firestore and get a reference to the service
    const db = getFirestore(app);
    const [task, setTask] = useState("");
    const [postedBy, setPostedBy] = useState("");
    const [loading, setLoading] = useState(false);

    const [selects, setSelects] = useContext(SelectContext);
    const [tasks, setTasks] = useContext(TaskContext);
    const [auth, setAuth] = useContext(AuthContext);

    const [totalView, setTotalView] = useContext(TotalViewContext);
    const [page, setPage] = useState();
    const array = []

    const { keyword, setKeyword, filteredTask } = useSearch('');





    // const getTotal = async () => {
    //     try {
    //         const q = query(collection(db, "task"), (orderBy('timeCreated', 'desc')));

    //         // const snapshot = await citiesRef.get();
    //         const querySnapshot = await getDocs(q);
    //         const array = []
    //         querySnapshot.forEach((doc) => {

    //             array.push(array)

    //         });
    //         setTotalView({ ...totalView, totalView: totalView.totalView, total: array.length })
    //         console.log("totalView", totalView)


    //     } catch (error) {

    //         console.log("error" + error)
    //     }
    // }

    useEffect(() => {
        setPostedBy(auth?.email)
        //    loadTask()
        loadRealTask()
        // getTotal()
        return () => {

        }
    }, [])


    const loadRealTask = async () => {
        const db = getDatabase();
        const loadTaskRef = query(ref(db, 'tasks/') ,limitToLast(5));
        
        const array = []
        onValue(loadTaskRef, (snapshot) => {
            const data=   snapshot.val()
           
            setTasks(Object.values(data).reverse())
            console.log(Object.values(data))
            setTimeout(() => {

                setTotalView(pre => ({ ...totalView, total: pre.total, totalView: array.length }))
            }, 2000)


        });
        
    }

    const loadRealMore=async()=>{
        const db = getDatabase();
        const loadTaskRef = query(ref(db, 'tasks/'),orderByKey(),endBefore(tasks[tasks.length-1].id) ,limitToLast(3));
        
        const array = []
        onValue(loadTaskRef, (snapshot) => {
            const data=   snapshot.val()
            setTasks(pre => ([...pre, ...Object.values(data).reverse()]))
            
            console.log(Object.values(data))
            setTimeout(() => {

                setTotalView(pre => ({ ...totalView, total: pre.total, totalView: array.length }))
            }, 2000)


        });
        
    }
    // const loadTask = async () => {

    // try {
    //     const q = query(collection(db, "task"), (orderBy('timeCreated', 'desc')), limit(5));
    //     const querySnapshot = await getDocs(q);
    //     const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
    //     setPage(lastVisible)
    //     const array = []
    //     querySnapshot.docs.forEach((doc) => {
    //         // doc.data() is never undefined for query doc snapshots
    //         const arrays = doc.data()
    //         arrays.id = doc.id
    //         array.push(arrays)
    //     });
    //     console.log("load", array);
    //     setTasks(array)
    //     setTimeout(() => {

    //         setTotalView(pre => ({ ...totalView, total: pre.total, totalView: array.length }))
    //     }, 2000)

    // } catch (error) {
    //     toast.error("error" + error.message)
    //     console.log("error" + error)

    // }

    // }


    const loadMore = async () => {
        //     try {
        //         let next
        //         if (page == null || page == undefined) {
        //             loadTask()
        //         } else {
        //             next = query(collection(db, "task"),
        //                 orderBy("timeCreated", 'desc'),
        //                 startAfter(page || 0),
        //                 limit(10));
        //             // 
        //             const nextSnapshot = await getDocs(next);

        //             nextSnapshot.docs.forEach((doc) => {
        //                 // doc.data() is never undefined for query doc snapshots
        //                 const arrays = doc.data()
        //                 arrays.id = doc.id
        //                 array.push(arrays)
        //             });
        //             console.log("load", array);
        //             setTasks(pre => ([...pre, ...array]))
        //             console.log(tasks)

        //             setTotalView(pre => ({ ...totalView, totalView: pre.totalView + array.length }))

        //             const lastVisible = nextSnapshot.docs[nextSnapshot.docs.length - 1];
        //             setPage(lastVisible)
        //             console.log("load", array);
        //         }



        //     } catch (error) {
        //         console.log("error" + error)
        //     }
    }

    const handleClick = async (task) => {

        const canUpdate = auth.email === task.postedBy

        setSelects({ select: task })
        setTasks(tasks)
        console.log(canUpdate)
    }

    return (
        <div className='container mt-2'>
            <div className="row">
                <div className='col-md-6 offset-md-3'>
                    <SearchBar keyword={keyword} setKeyword={setKeyword}/>
                    <pre className='text-center' style={{
                        textDecoration: "underline gold",
                        textDecorationThickness: "3px",
                    }}>
                        {totalView.total} total tasks, {totalView.totalView} view tasks
                    </pre>
                    {filteredTask?.map((task) => (
                        <div onClick={() => handleClick(task)}
                            key={task.id}
                            className=" rounded shadow p-2 m-2 tasklist"
                            style={{ background: auth.email === task.postedBy ? '#f2ffe6' : '#ffe6e6' }}>
                            <p>{task.task}</p>

                            <p className='float-end ' style={{ fontSize: "10px", marginTop: "-15px" }}>
                                {/* {String(dayjs(task.timeCreated).fromNow())} by  */}
                                <Timer time={task.timeCreated}  /> by 
                                <b> {task.postedBy}</b> </p>
                        </div>))
                    }
                </div>

                <div className='text-center mt-4 mb-4'>
                    <button className='btn btn-outline-warning' onClick={loadRealMore}>loadMore</button>
                </div>
            </div>

        </div>
    )

}
